import { Box, BoxProps, Skeleton } from '@mui/material';
import React, { forwardRef, useState } from 'react';
import imageIcon from 'assets/imageIcon.svg';

type Props = React.ImgHTMLAttributes<HTMLImageElement> &
  Omit<BoxProps, 'component'> & { errorSx?: BoxProps['sx'] };

const Image = forwardRef((props: Props, ref): JSX.Element | null => {
  const { src, errorSx, ...rest } = props;

  const [isBroken, setIsBroken] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleBrokenLink = () => {
    setIsBroken(true);
    setIsLoading(false);
  };

  const handleLoaded = () => {
    setIsLoading(false);
  };

  if (isBroken || !src) {
    return <Box sx={errorSx || rest.sx} component="img" src={imageIcon} />;
  }

  return (
    <>
      <Box
        {...rest}
        ref={ref}
        component="img"
        src={src}
        onError={handleBrokenLink}
        onLoad={handleLoaded}
        {...(isLoading && {
          style: {
            display: 'none',
          },
        })}
      />
      {isLoading && (
        <Skeleton
          variant="rectangular"
          animation="wave"
          {...(rest.sx && { sx: rest.sx })}
        />
      )}
    </>
  );
});

export default Image;
